import type {
  GetCollectingRequestCandidatesParams,
  GetCollectingRequestsParams,
  GetCollectingResultReportsParams,
  GetDeliveryResultReportsParams,
  TypeGetDashboardDeliveryStatusParams,
  TypeGetDashboardDeliveryTrendParams,
  TypeGetOrdersParams,
  TypeGetOutboundsListParams,
  TypeGetShippingLabelsParams,
} from '~/types/delivery-agency.types';

/**
 * [배송 관리] React Query Key Factory
 */
export const deliveryAgencyKeys = {
  all: ['delivery-agency'] as const,

  /** 배송 주문 검색 필터 코드 조회 */
  orderSearchConditions: () => [...deliveryAgencyKeys.all, 'orderSearchConditions'] as const,

  /** 배송 주문 리스트 조회 */
  orders: (params: TypeGetOrdersParams) => [...deliveryAgencyKeys.all, 'orders', params] as const,

  /** 운송장 관리 검색 필터 코드 조회 */
  shippingLabelsSearchConditions: () => [...deliveryAgencyKeys.all, 'shippingLabelsSearchConditions'] as const,

  /** 운송장 관리 리스트 조회 */
  shippingLabels: (params: TypeGetShippingLabelsParams) =>
    [...deliveryAgencyKeys.all, 'shippingLabels', params] as const,

  /** 합포 단위 관리 검색 필터 코드 조회 */
  outboundsSearchConditions: () => [...deliveryAgencyKeys.all, 'outboundsSearchConditions'] as const,

  /** 합포 단위 관리 리스트 조회 */
  outboundsList: (params: TypeGetOutboundsListParams) => [...deliveryAgencyKeys.all, 'outboundsList', params] as const,

  /** 실시간 배송 현황 조회 */
  dashboardDeliveryStatus: (params: TypeGetDashboardDeliveryStatusParams) =>
    [...deliveryAgencyKeys.all, 'dashboardDeliveryStatus', params] as const,

  /** 배송 추이 조회 */
  dashboardDeliveryTrend: (params: TypeGetDashboardDeliveryTrendParams) =>
    [...deliveryAgencyKeys.all, 'dashboardDeliveryTrend', params] as const,

  /** 배송 결과 리포트 검색 조건 코드 조회 */
  deliveryResultReportsSearchConditions: () =>
    [...deliveryAgencyKeys.all, 'deliveryResultReportsSearchConditions'] as const,

  /** 배송 결과 리포트 목록 조회 (검색 전 null 허용) */
  deliveryResultReports: (params: GetDeliveryResultReportsParams | null) =>
    [...deliveryAgencyKeys.all, 'deliveryResultReports', params] as const,

  /** 회수 신청 검색 조건 코드 조회 */
  collectingRequestsSearchConditions: () => [...deliveryAgencyKeys.all, 'collectingRequestsSearchConditions'] as const,

  /** 회수 신청 목록 조회 (검색 전 null 허용) */
  collectingRequests: (params: GetCollectingRequestsParams | null) =>
    [...deliveryAgencyKeys.all, 'collectingRequests', params] as const,

  /** [반품 신청 2step] 후보 원주문 상세 조회 (1step 선택 전 null 허용) */
  collectingRequestCandidateDetail: (outboundCode: string | null) =>
    [...deliveryAgencyKeys.all, 'collectingRequestCandidateDetail', outboundCode] as const,

  /** [반품 신청 2step] 회수 정보 입력 옵션 조회 */
  collectingRequestRegisterOptions: () => [...deliveryAgencyKeys.all, 'collectingRequestRegisterOptions'] as const,

  /** [반품 신청 1step] 후보 원주문 검색 조건 코드 조회 */
  collectingRequestCandidatesSearchConditions: () =>
    [...deliveryAgencyKeys.all, 'collectingRequestCandidatesSearchConditions'] as const,

  /** [반품 신청 1step] 후보 원주문 목록 조회 (검색 전 null 허용) */
  collectingRequestCandidates: (params: GetCollectingRequestCandidatesParams | null) =>
    [...deliveryAgencyKeys.all, 'collectingRequestCandidates', params] as const,

  /** 회수 결과 리포트 검색 조건 코드 조회 */
  collectingResultReportsSearchConditions: () =>
    [...deliveryAgencyKeys.all, 'collectingResultReportsSearchConditions'] as const,

  /** 회수 결과 리포트 목록·서머리 조회 (검색 전 null 허용) */
  collectingResultReports: (params: GetCollectingResultReportsParams | null) =>
    [...deliveryAgencyKeys.all, 'collectingResultReports', params] as const,
};
